import { Button, Card, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { useEffect } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import './InvitationGroupFilterPanel.less';

const VISIBLE_FIELD_COUNT = 3;

export default function InvitationGroupFilterPanel({ filter, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(VISIBLE_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            applicationItemName: filter.applicationItemName,
            name: filter.name,
            isTesting: filter.isTesting,
        });
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Card
            size="small"
            className="invitation-group-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="医会议名称" name="applicationItemName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入医会议名称" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="邀请组" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="请输入邀请组" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="正式/测试" name="isTesting" style={filterFormItemStyle}>
                            <Select placeholder="选择是否测试邀请组" allowClear>
                                <Select.Option value={0}>正式邀请组</Select.Option>
                                <Select.Option value={1}>测试邀请组</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
